module.exports = __webpack_public_path__ + "static/img/banner.b0dde43.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/banner.png
// module id = 541
// module chunks = 3